import React from 'react';

import { CheckCircleOutline, GroupOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import { PracticeStateRow } from './PracticeStatesTable.types';

export type StateNameCellProps = {
  value?: string;
  row: PracticeStateRow;
};

export const StateNameCell: React.FC<StateNameCellProps> = ({ value, row }) => {
  const icon = row.requiresCollabAgreement ? (
    <Tooltip title="Collaboration agreement required">
      <GroupOutlined fontSize="small" color="action" />
    </Tooltip>
  ) : (
    <Tooltip title="Ready - No requirements">
      <CheckCircleOutline fontSize="small" color="success" />
    </Tooltip>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {value}
      {icon}
    </Box>
  );
};
